/* eslint-disable react/jsx-no-target-blank */
import "./App.css";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "antd/dist/antd.min.css";
import News from "./components/News/News";
import NewsDetails from "./components/NewsDetails/NewsDetails";
import Home from "./components/Home/Home";
import OurVisions from "./components/OurVisions/OurVisions";
import Careers from "./components/Careers/Careers";
import Contact from "./components/Contact/Contact";
import Privacy from "./components/Privacy/Privacy";
import { ObjectiveProvider } from "./context/Objective";
import SubCategories from "./components/shared/Categories/SubCategories";
import SubscribeModal from "./components/SubscribeModal/SubscribeModal";

export const queryClient = new QueryClient();
function App() {
  return (
    <>
      <SubscribeModal />
      <QueryClientProvider client={queryClient}>
        <ObjectiveProvider>
          <Router>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/news" element={<News />} />
              <Route path="/news-details/:newsId" element={<NewsDetails />} />
              <Route path="/our-story" element={<OurVisions />} />
              <Route path="/careers" element={<Careers />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/privacy-policy" element={<Privacy />} />
              {/* <Route
              path="/solutions/critical-infrastructure"
              element={<Solution />}
            />
            <Route
              path="/solutions/cybersecurity"
              element={<Cybersecurity />}
            />
            <Route path="/solutions/healthcare" element={<HealthCare />} />
            <Route path="/solutions/realestate" element={<RealState />} />
            <Route path="/solutions/smartcities" element={<SmartCities />} /> */}
              <Route path="/solutions/:subCat" element={<SubCategories />} />
            </Routes>
          </Router>
        </ObjectiveProvider>
      </QueryClientProvider>
    </>
  );
}

export default App;
